module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/ts-loader/index.js??ruleSet[1].rules[1].use[0]!./partners-list.ts"));
	}, "partners-module");
}